import { db } from '@/firebase.js'
import dataService from '@/DataSyncService'

const userAccess = {
  state: {
    Privilege: false,
    UmbracoConnection: false,
  },
  mutations:{
    setPrivilege(state, hasAccess){
      state.Privilege = hasAccess
    },
    setUmbracoConnection(state, status){
      state.UmbracoConnection = status
    }
  },
  actions: {
    async checkUserAccess({commit}){
      const storedToken = localStorage.getItem('Opskrifter_Token')
      let hasAccess = false
      if(storedToken){
        const userId =  await db.collection('UserLogins').doc(storedToken).get()
        hasAccess = userId.exists
      }
      commit('setPrivilege', hasAccess)
    },
    async checkUmbracoConnection({commit}){
      commit('setUmbracoConnection', await dataService.checkUmbracoConnection())
    }
  },
  getters: {
    hasPrivilege: state => state.Privilege,
    hasUmbracoConnection: state => state.UmbracoConnection,
  }
}
export default userAccess